<template>
    <div>
      <div class="wrapper">
        <the-header />
        <div class="d-flex flex-column flex-lg-row align-items-start">
          <the-sidebar />
          <main class="flex-grow-1 w-100" style="min-width: 0">
            <slot />
          </main>
        </div>
      </div>
    </div>
  </template>
  <script>
  import TheHeader from '../components/Common/TheHeader.vue'
  import TheSidebar from '../components/Common/TheSIdebar.vue'
  export default {
    components: {
      TheHeader,
      TheSidebar
    }
  }
  
  </script>